/* ==========================================================================
   sk-cart-bridge.js — verbindet den Silberkraft-Warenkorb-Drawer (sk-drawer.js) mit Horizon
   --------------------------------------------------------------------------
   Horizon-Theme: settings.cart_type = 'page' (Horizons eigener cart-drawer wird nicht gerendert).
   - Klick auf das Header-Warenkorb-Icon (.action__cart, außer auf /cart) → sk-Drawer statt Seitenwechsel
   - Artikel in den Warenkorb (CartLinesUpdateEvent, action 'add') → Drawer öffnet nach der Antwort
     (Empire-Parität: assets/sk-atc-smart-flow.js)
   - Biozid-Video-Gate: Videodaten der Warenkorb-Artikel kommen aus /cart?view=sk-video und werden in
     window.skVideoData / skVideoProductIds nachgeladen, bevor der Drawer öffnet (Empire: Page-Reload mit
     ?sk_drawer_open=1). Kein Reload nötig.
   - Cmd/Ctrl/Shift-Klick bleibt normaler Link.
   ========================================================================== */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var VIDEO_VIEW = '/cart?view=sk-video';

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function loadVideoData() {
    return fetch(VIDEO_VIEW, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (data) {
        data = data || {};
        window.skVideoData = window.skVideoData || {};
        window.skVideoProductIds = window.skVideoProductIds || [];
        Object.keys(data).forEach(function (pid) {
          window.skVideoData[pid] = data[pid];
          if (window.skVideoProductIds.indexOf(Number(pid)) === -1) window.skVideoProductIds.push(Number(pid));
        });
        window.skCart = window.skCart || {};
        if (Object.keys(data).length && !window.skCart.isReturning) window.skCart.hasVideo = true;
      })
      .catch(function () {});
  }

  function openDrawer() {
    if (window.skDrawer && typeof window.skDrawer.open === 'function') {
      return loadVideoData().then(function () { window.skDrawer.open(); });
    }
    window.location.href = '/cart';
    return Promise.resolve();
  }

  // Header-Icon
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var trg = e.target.closest('.action__cart, [data-sk-open-drawer]');
    if (!trg || !window.skDrawer) return;
    if (isCartPage() && !trg.hasAttribute('data-sk-open-drawer')) return;
    e.preventDefault();
    openDrawer();
  }, true);

  // Artikel hinzugefügt (Horizon product-form / quick-add / Karten)
  function onCartLinesUpdate(event) {
    if (!event || event.action !== 'add' || isCartPage()) return;
    // Mengen-Upsell (Philipp 31.10.2026, assets/sk-upsell.js): übernimmt ggf. und öffnet den Drawer nach der Entscheidung
    try { if (window.skUpsell && window.skUpsell.claim(event, openDrawer)) return; } catch (_) {}
    var p = event.promise;
    if (p && typeof p.then === 'function') {
      p.then(function () { openDrawer(); }).catch(function () {});
    }
  }
  // Eventname = StandardEvents.cartLinesUpdate (@shopify/events). Literal statt import(): der Shopify-CDN
  // transpiliert dynamische imports in Klassik-Skripten zu require() und bricht sie.
  document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);
})();
